// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__Ny3U1","badges":"styles_badges__2uZXI"};